import React, { useState, useEffect } from 'react';

import { Link, useParams } from 'react-router-dom';

import { Header, Footer, HeaderBox } from '../../components/imports'

import { HeaderProfile, ProfileMenu } from '../../components/profile'

import { APP_NAME } from '../../constants/general'

import Func from '../../class/Func'

import User from '../../class/User'
    
import Moment from 'react-moment'
import 'moment/locale/fr'

function EvaluationsPublique() {

    const { id } = useParams()

    const [avis, setAvis] = useState(false)

    const getAvis = async () => {

        let results = await User.avis(id)

        if(results.success){

            setAvis(results.data)

        }else{

            setAvis(results.message)

        }

    }

    useEffect(() => {

        getAvis()

        document.title = "Mes évaluations - " + APP_NAME

    }, [])

    return (

        <div>

         <Header />
                
            <div className="profil">

            <HeaderBox />

            <div className='content pos-r'>

                <div className="c">

                    <a href="" className='cl2 textUnd fz09'>Profil</a>
                    
                    <HeaderProfile id={ id }/>

                </div>

                <div className="mt30">

                    <div className="c pos-r">

                        <ProfileMenu data="evaluations" id={ id }/>

                        <div className="p-ratings">

                        {

                            avis

                            ?

                                typeof avis === "string"

                                ?

                                <p className='fz09'>{ avis }</p>

                                :

                                <>
                                    
                                    {
                                    
                                    avis.map(av =>

                                        <div className="note bg6" key={ av.idA }>
                                            <div className="flex ai-center">
                                                <div className='user m_mb_20'>

                                                    <div className="av">
                                                        <img src={ Func.avatar(av.avatar) }/>
                                                    </div>

                                                    { av.name !== null ? <Link to={ "/profile/" + av.idU } className="t cl2">{ av.name }</Link> : 'Sisters Green' }

                                                    { Func.note(av.note) }

                                                </div>

                                                <span className='date'><Moment locale="fr" fromNow>{ av.date }</Moment></span>

                                            </div>

                                            <p className='flex jc-start ai-center mb0 m_flex'>
                                                
                                                {av.avis_type == 'ps' && <img src="/image/icon-arrosage.svg" style={{ width: '35px', height: '35px', borderRadius: 0, marginRight: '10px' }} />}
                                            
                                                { av.text }
                                            
                                            </p>
                                            
                                        </div>

                                    )
                                    
                                    }

                                </>

                            :

                            <div className='flex jc-center mt50 mb50'>
                                <div className="lds-dual-ring col"></div>
                            </div>

                        }

                        </div>

                    </div>
                </div>
            </div>

            </div>

            <Footer/>

        </div>

    )

}

export default EvaluationsPublique